import React, { useState } from 'react';
import { formatRupiah, scrollToSection } from '../../components/Common/utils';
import ConditionalRender from '../../components/Common/ConditionalRender';
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

function NominalList({
    itemProduct,
    productLoading,
    selectedNominalItems,
    setselectedNominalItems,
    setSelectedPaymentItems,
    inputForms
}) {
    const [tabNominal, setTabNominal] = useState(0);

    return (
        <div className="flex flex-col gap-3 rounded-lg min-h-[200px] shadow-inner bg-cardLight dark:bg-cardDark" id={'nominal'}>
            <div className="flex flex-row items-center gap-1 rounded-md  bg-[#22BDE2] text-darkColor">
                <div className=' items-center justify-center flex rounded-md bg-gradient-to-r from-[#22BDE2] to-[#FC00FF]  p-3 h-12 w-12 '>
                <span className="font-bold hidden sm:flex">
                        1
                    </span>
                    <span className="font-bold sm:hidden flex">
                        {inputForms.length !== 0 ? "2" : "1"}
                    </span>
                </div>
                <span className="text-base px-3 font-medium line-clamp-1">
                    Pilih Nominal
                </span>
            </div>
            <ConditionalRender
                productsData={itemProduct}
                isLoading={productLoading}
                model={"emptyItem"}
            >
                {itemProduct.length !== 1 && <span className="text-base px-3 font-medium line-clamp-1">
                    Kategori
                </span>}
                {itemProduct.length !== 1 && <div className="flex flex-col z-0 relative sm:h-24 h-24">
                    <div className=" absolute top-0 left-0 right-0 bottom-0">
                        <Swiper
                            className="w-full h-full px-3 py-1"
                            spaceBetween={10}
                            breakpoints={{
                                0: {
                                    slidesPerView: 3,
                                },
                                640: {
                                    slidesPerView: 4,
                                },
                                768: {
                                    slidesPerView: 4,
                                },
                                1024: {
                                    slidesPerView: 5,
                                },
                                1280: {
                                    slidesPerView: 5,
                                },
                                1536: {
                                    slidesPerView: 5,
                                },
                            }}
                            modules={[Autoplay]}
                        >
                            {itemProduct.map((item, index) => {
                                return (item.jenis_layanan === "Default" ? null :
                                    <SwiperSlide
                                        key={index}
                                        className={`flex ${index === tabNominal ? "bg-gradient-to-r from-[#22BDE2] to-[#FC00FF] text-darkColor" : "bg-[#DFF9FF] dark:bg-darkColor"}  rounded-md `}
                                    >
                                        <button key={index}
                                            onClick={() => {
                                                if (index === tabNominal) {
                                                    setTabNominal(0);

                                                } else {
                                                    setTabNominal(index);
                                                }
                                            }}
                                            className={`flex flex-col items-center justify-center gap-1  h-full w-full`}>
                                            {item.gambar_jenis !== "" &&
                                                <img
                                                    alt={item.jenis_layanan}
                                                    src={item.gambar_jenis} className={` w-7 h-7`} />
                                            }
                                            <span className={` ${tabNominal === index ? "font-medium opacity-100" : "opacity-60"} text-sm text-center line-clamp-3 `}>
                                                {item.jenis_layanan}
                                            </span>
                                        </button>
                                    </SwiperSlide>
                                )
                            })}
                        </Swiper>
                    </div>
                </div>}
                <span className="text-base px-3 font-medium line-clamp-1">
                    Nominal
                </span>
                <div className="grid grid-cols-2 md:grid-cols-3 gap-2  px-3 pb-3">
                    {itemProduct[tabNominal]?.items.map((item, index) => {
                        const getWebProfile = JSON.parse(localStorage.getItem("isProfile"));
                        const selectedPriceLevel =
                            getWebProfile?.level === "member"
                                ? item.harga
                                : getWebProfile?.level === "silver"
                                    ? item.harga_silver
                                    : getWebProfile?.level === "pro"
                                        ? item.harga_pro
                                        : getWebProfile?.level === "gold"
                                            ? item.harga_gold
                                            : item.harga;
                        const diskonoff =
                            getWebProfile?.level === "member"
                                ? item.diskon_off
                                : getWebProfile?.level === "silver"
                                    ? item.diskon_off_silver
                                    : getWebProfile?.level === "pro"
                                        ? item.diskon_off_pro
                                        : getWebProfile?.level === "gold"
                                            ? item.diskon_off_gold
                                            : item.diskon_off;
                        const logicFee = () =>
                            item.status_diskon === "Aktif" ? (
                                <div className={`flex flex-col items-start  ${selectedNominalItems?.id === item.id && 'mb-2'}`}>
                                    <span className={` text-xs text-left font-bold ${selectedNominalItems?.id === item.id ? 'text-darkColor ':'text-[#22BDE2]'} line-clamp-1 `}>
                                        {formatRupiah(selectedPriceLevel)}
                                    </span>
                                    <span className={`opacity-60 text-xs text-left  line-clamp-1 ${selectedNominalItems?.id === item.id ? 'text-darkColor ':'text-[#E57373]'}`}
                                        style={{ textDecoration: "line-through" }}
                                    >
                                        {formatRupiah(item.harga_diskon)}
                                    </span>
                                </div>
                            ) : (
                                <span className={` text-left  text-xs line-clamp-1  ${selectedNominalItems?.id === item.id ? 'text-darkColor ':'text-[#22BDE2]'}`}>
                                    {formatRupiah(selectedPriceLevel)}
                                </span>
                            );
                        const ribbon = () =>
                            item.status_diskon == "Aktif" ? (
                                // <div className="ribbon">
                                //   <span>{diskonoff}% OFF</span>
                                // </div>
                                <div className="absolute right-0 top-0 p-0.5 px-2 bg-[#FFA000] rounded-bl-md rounded-tr-md">
                                    <span className="text-[#ffffff] text-[10px] line-clamp-1">
                                        {diskonoff}% OFF
                                    </span>
                                </div>
                            ) : null;
                        return (
                            <button key={index}
                                onClick={() => {
                                    setselectedNominalItems(item);
                                    setSelectedPaymentItems([])
                                    scrollToSection('payment')
                                }}
                                className={`flex flex-row items-center justify-between gap-2 rounded-lg border-2 p-2 ${item.status_diskon === "Aktif" && 'pt-3'} bg-[#DFF9FF] dark:bg-darkColor w-full relative group  ${selectedNominalItems?.id === item.id ? ' bg-gradient-to-r from-[#22BDE2] to-[#FC00FF] text-darkColor' : 'text-[#22BDE2] border-transparent'}`}>

                                {ribbon()}
                                <div className="flex flex-col flex-1 ">
                                    <div className={`flex flex-col ${item.status_diskon == "Aktif" && 'pt-2'}`}>
                                        <span className={` text-xs  font-semibold text-left  line-clamp-4`}>
                                            {item.layanan}
                                        </span>
                                    </div>
                                    {logicFee()}
                                    {item.point !== "0" && <span className={`text-xs text-left font-semibold `}>
                                        + {item.point} Poin</span>}
                                </div>
                                {item.icon_layanan && (<img
                                    src={item.icon_layanan}
                                    alt={'icon_item ' + index} className="flex flex-col w-7 aspect-square rounded-full" />)}
                               
                            </button>
                        )
                    })}
                </div>
            </ConditionalRender>
        </div>
    );
}

export default NominalList;
